module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAA2UlEQVQokX3SvUoDURDF8V+WaO8jpLERBNkXsLHcmNgK+gZ+vISxENHe1kYsRCJoYmFrekufQxLBpNhdmFw2nu7cO/975jLT2nq/0KA+zpDjD1181JftBuAWJ8G/4TMWZAlwlACv6OEnFqVJp0lCD9Nwto7tCK1hJ/irBuARu7G9FubBX2IjAQpkEZrhO/gcY+zhqQJgEtsr0LGsHKPk7KZOKqr4phFEDfDcxj4eqr5r/eILm8p/TnCNoerl+wSY4QAvq+Iy3AU/Vc5mJVAnnSv36xiHyi34VwsKESjmeWevBQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/handle-time-icon.png
// module id = hycf
// module chunks = 1